import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _78fdf8f4 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _59a006fa = () => interopDefault(import('..\\pages\\landing.vue' /* webpackChunkName: "pages_landing" */))
const _28f4ff16 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _69f42c6f = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _ca72c190 = () => interopDefault(import('..\\pages\\terms-and-conditions.vue' /* webpackChunkName: "pages_terms-and-conditions" */))
const _14a1a208 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _5481a895 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _548fc016 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _54abef18 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _54ba0699 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _ed303854 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _f47d54c4 = () => interopDefault(import('..\\pages\\need-a-card\\eligibility.vue' /* webpackChunkName: "pages_need-a-card_eligibility" */))
const _5ce9b7f5 = () => interopDefault(import('..\\pages\\need-a-card\\patient-information.vue' /* webpackChunkName: "pages_need-a-card_patient-information" */))
const _956aed3c = () => interopDefault(import('..\\pages\\need-a-card\\program-consent.vue' /* webpackChunkName: "pages_need-a-card_program-consent" */))
const _3537dabe = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _78fdf8f4,
    name: "error"
  }, {
    path: "/landing",
    component: _59a006fa,
    name: "landing"
  }, {
    path: "/rejection",
    component: _28f4ff16,
    name: "rejection"
  }, {
    path: "/success",
    component: _69f42c6f,
    name: "success"
  }, {
    path: "/terms-and-conditions",
    component: _ca72c190,
    name: "terms-and-conditions"
  }, {
    path: "/unlock",
    component: _14a1a208,
    name: "unlock"
  }, {
    path: "/errors/400",
    component: _5481a895,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _548fc016,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _54abef18,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _54ba0699,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _ed303854,
    name: "errors-500"
  }, {
    path: "/need-a-card/eligibility",
    component: _f47d54c4,
    name: "need-a-card-eligibility"
  }, {
    path: "/need-a-card/patient-information",
    component: _5ce9b7f5,
    name: "need-a-card-patient-information"
  }, {
    path: "/need-a-card/program-consent",
    component: _956aed3c,
    name: "need-a-card-program-consent"
  }, {
    path: "/",
    component: _3537dabe,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
